import React from 'react';

import ClippedImage from 'common/components/ClippedImage/ClippedImage';
import TextBlock from 'common/components/Placeholder/components/TextBlock/TextBlock';

import styles from './AuthoritiesPlaceholder.module.scss';

const AuthoritiesPlaceholder = () => (
  <div className={styles.AuthoritiesPlaceholder}>
    <ClippedImage
      id="1"
      width={220}
      height={260}
      borderColor={styles.PlaceholderDefaultColor}
      url=""
    />
    <ClippedImage
      id="2"
      width={100}
      height={120}
      borderColor={styles.PlaceholderDefaultColor}
      url=""
    />
    <TextBlock
      rows={4}
      color={styles.PlaceholderDefaultColor}
      className={styles.TextBlock}
    />
  </div>
);

export default AuthoritiesPlaceholder;



// WEBPACK FOOTER //
// ./src/views/Authorities/placeholder/AuthoritiesPlaceholder.js